import React from "react";
import { Edit, Trash2 } from "lucide-react";
import { showSuccessToast, showErrorToast } from "../../../components/ConfirmDialog";
import { confirmDelete, DELETE_ENTITY } from "../../../utils/confirmDelete";
import { deleteUserRole } from "../../../api/settings/user_roles";
import { hasPermission } from "../../../utils/permissionUtils"; // ✅ kiểm tra quyền

const RowActions = ({ data, onEdit, onDeleted }) => {
  const handleDelete = async () => {
    const confirm = await confirmDelete({
      type: DELETE_ENTITY.user_role,
      name: data?.full_name,
    });

    if (confirm.isConfirmed) {
      try {
        await deleteUserRole(data.employee_id, data.role_id);
        showSuccessToast("Đã xoá phân quyền nhân viên");
        onDeleted?.();
      } catch (err) {
        console.error("Lỗi khi xoá phân quyền:", err);
        showErrorToast("Lỗi khi xoá phân quyền");
      }
    }
  };

  return (
    <div className="flex gap-2">
      {/* Chỉ người có quyền cập nhật mới được sửa */}
      {hasPermission("settings.user_roles", "U") && (
        <button onClick={() => onEdit?.(data)} title="Chỉnh sửa phân quyền">
          <Edit size={18} className="text-yellow-600 hover:scale-110" />
        </button>
      )}

      {/* Chỉ người có quyền xoá mới được gỡ quyền */}
      {hasPermission("settings.user_roles", "D") && (
        <button onClick={handleDelete} title="Xoá phân quyền">
          <Trash2 size={18} className="text-red-600 hover:scale-110" />
        </button>
      )}
    </div>
  );
};

export default RowActions;
